import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
import { pathFromAppUrl, nativeColdStartPath } from './appDeepLink';
import { enablePortalV2Session } from './portalV2';

function navigateInApp(path) {
    if (!path) return;
    if (typeof window.__oolaNavigate === 'function') {
        window.__oolaNavigate(path);
        return;
    }
    window.__oolaPendingPath = path;
}

/**
 * Native shell hooks for Capacitor (no-op on web).
 * Call once at app boot from index.js.
 */
export async function initCapacitorNative() {
    if (!Capacitor.isNativePlatform()) {
        return;
    }

    enablePortalV2Session();

    const platform = Capacitor.getPlatform();
    document.documentElement.classList.add('is-native-app', `is-native-${platform}`);

    try {
        await StatusBar.setStyle({ style: Style.Dark });
        if (platform === 'android') {
            await StatusBar.setBackgroundColor({ color: '#022B7A' });
        }
    } catch (err) {
        console.warn('[capacitor] StatusBar', err);
    }

    try {
        await Keyboard.setResizeMode({ mode: KeyboardResize.Body });
    } catch (err) {
        console.warn('[capacitor] Keyboard', err);
    }

    CapApp.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack || window.history.length > 1) {
            window.history.back();
            return;
        }
        CapApp.exitApp();
    });

    CapApp.addListener('appUrlOpen', ({ url }) => {
        const path = pathFromAppUrl(url);
        if (path) navigateInApp(path);
    });

    try {
        const launch = await CapApp.getLaunchUrl();
        if (launch?.url) {
            const path = pathFromAppUrl(launch.url);
            if (path) navigateInApp(path);
        } else {
            const cold = nativeColdStartPath(window.location.pathname);
            if (cold) navigateInApp(cold);
        }
    } catch (err) {
        const cold = nativeColdStartPath(window.location.pathname);
        if (cold) navigateInApp(cold);
        console.warn('[capacitor] getLaunchUrl', err);
    }

    try {
        await SplashScreen.hide();
    } catch (err) {
        console.warn('[capacitor] SplashScreen', err);
    }
}

export function isNativeApp() {
    return Capacitor.isNativePlatform();
}
